import { UiThemePreference } from '@app/core/states/app.store';

const MEDIA_QUERY_DARK = '(prefers-color-scheme: dark)';
const THEME_COLOR_DARK = '#292524';
const THEME_COLOR_LIGHT = '#f5f5f4';

export const getDarkModeMediaQuery = (): MediaQueryList | null => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return null;
  }

  return window.matchMedia(MEDIA_QUERY_DARK);
};

export const resolveIsDarkTheme = (theme: UiThemePreference, prefersDark: boolean): boolean => {
  if (theme === 'dark') {
    return true;
  }

  if (theme === 'light') {
    return false;
  }

  return prefersDark;
};

export const applyRootThemeClass = (isDark: boolean, root: HTMLElement = document.documentElement): void => {
  root.classList.toggle('p-dark', isDark);
};

export const updateThemeColorMeta = (isDark: boolean, doc: Document = document): void => {
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!meta) {
    return;
  }

  meta.content = isDark ? THEME_COLOR_DARK : THEME_COLOR_LIGHT;
};

type MediaQueryChangeListener = (event: MediaQueryListEvent) => void;

type LegacyMediaQueryList = MediaQueryList & {
  addListener?: (listener: MediaQueryChangeListener) => void;
  removeListener?: (listener: MediaQueryChangeListener) => void;
};

export const subscribeToDarkModeChanges = (mediaQueryList: MediaQueryList, callback: () => void): (() => void) => {
  const legacyMediaQueryList = mediaQueryList as LegacyMediaQueryList;
  const listener: MediaQueryChangeListener = () => callback();

  if (typeof mediaQueryList.addEventListener === 'function') {
    mediaQueryList.addEventListener('change', listener);
    return () => mediaQueryList.removeEventListener('change', listener);
  }

  if (typeof legacyMediaQueryList.addListener === 'function') {
    legacyMediaQueryList.addListener(listener);
    return () => legacyMediaQueryList.removeListener?.(listener);
  }

  return () => void 0;
};
